export const getHoursPending = () => {
    return {
        type: 'GET_HOURS_PENDING'
    }
};

export const getColdHoursSuccess = (coldHours) => {
    return {
        type: 'GET_COLD_HOURS_SUCCESS',
        coldHours,

    }
};

export const selectHour = (hour) => {
    return {
        type: 'SELECT_HOUR',
        selected: { hour }
    };
};

export const getHoursError = error => {
    return {
        type: 'GET_HOURS_ERROR',
        error: error
    }
};

export const getColdHours = () => {
    return dispatch => {
        dispatch(getHoursPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/getColdConfigList`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getHoursError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getColdHoursSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};


export const addColdHour = obj => {
    return dispatch => {
        dispatch(getHoursPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/addNewColdConfig`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj),
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getColdHours());
                } else {
                    dispatch(getHoursError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const updateColdHour = obj => {
    return dispatch => {
        dispatch(getHoursPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/updateColdConfig`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj),
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getColdHours());
                } else {
                    dispatch(getHoursError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const deleteColdHour = (configId) => {
    return dispatch => {
        dispatch(getHoursPending());

        fetch(`${process.env.REACT_APP_API_URL}/sensor/deleteColdConfig?configId=${configId}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getColdHours());
                } else {
                    dispatch(getHoursError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
